// ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
    const [selectedOption, setSelectedOption] = useState(
        localStorage.getItem('selectedOption') || 'blue'
    );

    const handleOptionClick = (name) => {
        setSelectedOption(name);
        localStorage.setItem('selectedOption', name);
    };

    const [darkmode, setDarkmode] = useState(
        localStorage.getItem('darkmodeState') === 'true'
    );

    useEffect(() => {
        if (darkmode) {
            document.documentElement.setAttribute('data-theme', 'dark');
            localStorage.theme = 'dark';
        } else {
            document.documentElement.setAttribute('data-theme', 'light');
            localStorage.theme = 'light';
        }
        localStorage.setItem('darkmodeState', darkmode);
    }, [darkmode]);

    function toggle_darkmode() {
        setDarkmode(prevState => !prevState);
    }

    const [isActive, setActive] = React.useState(window.innerWidth >= 1200);
    const sidebarToggle = () => {
        setActive(!isActive);
    }
    useEffect(() => {
        if (window.innerWidth < 1200) {
            document.body.classList[isActive ? "add" : "remove"]("overflow-hidden")
        }
    }, [isActive])

    const [miniSidebar, setMiniSidebar] = useState(
        localStorage.getItem('miniSidebarState') === 'true'
    );
    const toggle_miniSidebar = () => {
        setMiniSidebar(prevState => !prevState);
    }
    useEffect(() => {
        localStorage.setItem('miniSidebarState', miniSidebar);
    }, [miniSidebar]);

    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <ThemeContext.Provider value={{ selectedOption, handleOptionClick, toggle_darkmode, darkmode, isActive, setActive, sidebarToggle, toggle_miniSidebar, miniSidebar, isHovered, handleMouseEnter, handleMouseLeave }}>
            {children}
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
    return useContext(ThemeContext);
};
